// extracted by mini-css-extract-plugin
export default {"wrapper":"_87366630","letter":"_4259233d","divider":"_249d6ee2"};